import React from 'react'
import { Link } from '@chakra-ui/react'
import guideData from '../../../constants/steps.json'

export default function Index({
  path,
  setPath,
}: {
  path: string
  setPath: (stepString: string, step: number) => void
}) {
  return (
    <nav>
      <ul>
        {guideData.map((step, index) => (
          <>
            <li
              key={`index-item-${index + 1}`}
              className={`flex h-8 w-full flex-row items-center justify-center pl-2 ${path === `#paso-${index + 1}` ? 'bg-gray-200' : ''}`}
              onClick={() => setPath(`#paso-${index + 1}`, index)}
            >
              <Link
                href={`#paso-${index + 1}`}
                className="flex w-full flex-row items-center justify-start gap-8"
              >
                Paso {index + 1}
                {step?.navTitle ? ':' : ''} {step?.navTitle}
              </Link>
            </li>
            {step?.steps?.map((step, idx) => (
              <li
                key={`index-item-${index + 1}-${idx + 1}`}
                className={`flex h-8 w-full flex-row items-center justify-center pl-8 ${path === `#paso-${index + 1}-${idx + 1}` ? 'bg-gray-200' : ''}`}
                onClick={() => setPath(`#paso-${index + 1}-${idx + 1}`, index)}
              >
                <Link
                  href={`#paso-${index + 1}-${idx + 1}`}
                  className="flex w-full flex-row items-center justify-start gap-8"
                >
                  Paso {index + 1}.{idx + 1}
                  {step?.navTitle ? ':' : ''} {step?.navTitle}
                </Link>
              </li>
            ))}
          </>
        ))}
      </ul>
    </nav>
  )
}
